export const fmtCurrency = (n) =>
  '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 0 });

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    return new Date(d + (d.includes('T') ? '' : 'T12:00:00')).toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
    });
  } catch { return d; }
};

export const fmtTime = (t) => {
  if (!t) return '';
  try {
    return new Date(t).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  } catch { return t; }
};

export const initials = (name) =>
  (name || '?').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

export const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

export const statusLabel = (s) => ({
  scheduled: 'Scheduled',
  'in-progress': 'In Progress',
  'final-inspection': 'Final Inspection',
  completed: 'Completed',
  'on-hold': 'On Hold',
  cancelled: 'Cancelled',
}[s] || s);

export const statusColors = (s) => ({
  scheduled:        { bg: '#EFF6FF', color: '#1D4ED8' },
  'in-progress':    { bg: '#FFF7ED', color: '#C2410C' },
  'final-inspection': { bg: '#FEFCE8', color: '#A16207' },
  completed:        { bg: '#DCFCE7', color: '#15803D' },
  'on-hold':        { bg: '#F1F5F9', color: '#475569' },
  cancelled:        { bg: '#FEF2F2', color: '#991B1B' },
}[s] || { bg: '#F1F5F9', color: '#475569' });

export const PHASE_TEMPLATES = {
  'Full Replacement': [
    'Initial Inspection & Estimate','Contract Signed','Material Ordered',
    'Material Delivered','Permit Obtained','Tear-Off & Decking Inspection',
    'Underlayment & Flashing','Shingle / Panel Installation',
    'Ridge Cap & Ventilation','Gutters & Trim','Final Cleanup',
    'Final Inspection','Customer Walkthrough','Project Closed',
  ],
  'Leak Repair': [
    'Initial Inspection','Contract Signed','Material Ordered',
    'Repair Work','Water Test','Final Sign-Off',
  ],
  'Storm Damage': [
    'Damage Assessment','Insurance Claim Filed','Insurance Approval',
    'Contract Signed','Material Ordered','Material Delivered',
    'Tear-Off','Installation','Final Inspection','Insurance Settlement','Project Closed',
  ],
  'New Construction': [
    'Initial Consultation','Plans Review','Permit Obtained',
    'Material Ordered','Material Delivered','Underlayment',
    'Installation','Trim & Flashing','Final Inspection','Project Closed',
  ],
  'Gutter Replacement': [
    'Initial Inspection','Contract Signed','Material Ordered',
    'Old Gutter Removal','New Gutter Installation','Final Inspection','Sign-Off',
  ],
  'Emergency Repair': [
    'Emergency Assessment','Temporary Tarping','Contract Signed',
    'Material Ordered','Repair Work','Water Test','Final Sign-Off',
  ],
};

export const MATERIAL_CATALOG = [
  { id:'m1',  name:'Architectural Shingles (GAF Timberline HDZ)', unit:'sq',     unitCost:95,  category:'Shingles' },
  { id:'m2',  name:'3-Tab Shingles (Owens Corning)',              unit:'sq',     unitCost:68,  category:'Shingles' },
  { id:'m3',  name:'Metal Standing Seam Panels',                  unit:'sq',     unitCost:320, category:'Metal' },
  { id:'m4',  name:'Ice & Water Shield',                          unit:'sq',     unitCost:42,  category:'Underlayment' },
  { id:'m5',  name:'Synthetic Underlayment',                      unit:'sq',     unitCost:18,  category:'Underlayment' },
  { id:'m6',  name:'OSB Decking 7/16"',                           unit:'sheet',  unitCost:28,  category:'Decking' },
  { id:'m7',  name:'Ridge Cap Shingles',                          unit:'bundle', unitCost:55,  category:'Shingles' },
  { id:'m8',  name:'Drip Edge (aluminum)',                        unit:'piece',  unitCost:8,   category:'Flashing' },
  { id:'m9',  name:'Step Flashing',                               unit:'piece',  unitCost:4,   category:'Flashing' },
  { id:'m10', name:'Roof Nails (1-3/4")',                         unit:'box',    unitCost:22,  category:'Fasteners' },
  { id:'m11', name:'Ridge Vent (linear ft)',                      unit:'ft',     unitCost:6,   category:'Ventilation' },
  { id:'m12', name:'Soffit Vent',                                 unit:'each',   unitCost:12,  category:'Ventilation' },
  { id:'m13', name:'6" K-Style Gutter',                           unit:'ft',     unitCost:9,   category:'Gutters' },
  { id:'m14', name:'Downspout',                                   unit:'each',   unitCost:45,  category:'Gutters' },
  { id:'m15', name:'Pipe Boot Flashing',                          unit:'each',   unitCost:15,  category:'Flashing' },
  { id:'m16', name:'Caulk / Sealant',                             unit:'tube',   unitCost:8,   category:'Sealants' },
];
